module.exports = __webpack_public_path__ + "static/media/border-center-v.1a99b99a.svg";